import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Dialog, IconButton, Link, Typography, DialogContent, Button } from '@material-ui/core';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { appRoutes } from 'routes';
import ForgotPasswordForm from 'sharedComponents/ForgotPasswordForm';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';

import { GET_ENUMS } from 'const/router';
import { getServerError } from 'utils/errors';
import useResetPassword from 'reducers/hooks/auth/useResetPassword';
import useStyles from './useStyles';

const ForgotPassword = props => {
  const { onClose } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { resetPassword, successMessage } = useResetPassword();
  const { isMobile } = useScreen();
  const { pathname } = useLocation();
  const [isSuccessScreenOpened, setSuccessScreenOpened] = useState(false);

  const handleSubmit = async (values, { setErrors }) => {
    const params = { ...values, redirectUrl: appRoutes.resetPasswordPath() };
    try {
      await resetPassword(params);
      setSuccessScreenOpened(true);
    } catch (error) {
      const errorMessage = getServerError(error);
      setErrors({ email: errorMessage });
    }
  };

  const handleCloseSuccessScreen = () => setSuccessScreenOpened(false);

  return (
    <div>
      <Dialog open onClose={onClose} fullScreen={isMobile}>
        <IconButton className={classes.dialogClose} onClick={onClose}>
          <Icon name="bigClose" />
        </IconButton>
        <DialogContent>
          {isSuccessScreenOpened ? (
            <div className={classes.content}>
              <Typography variant="h1">{t('components.ForgotPassword.header')}</Typography>
              <Typography className={classes.message} variant="body1">
                {successMessage}
              </Typography>
              <div className={classes.action}>
                <Typography variant="h3">{t('components.ForgotPassword.didReceive')}</Typography>
                <Button onClick={handleCloseSuccessScreen} variant="text">
                  {t('components.ForgotPassword.tryAgain')}
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <ForgotPasswordForm onSubmit={handleSubmit} />
              <div className={classes.links}>
                <Link
                  to={{ pathname, search: `?popup=${GET_ENUMS.popup.login}` }}
                  component={RouterLink}
                  className={classes.link}
                >
                  {t('components.ForgotPassword.login')}
                </Link>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

ForgotPassword.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js